import { QueueManager } from '@or-sdk/queue-manager';
import _ from 'lodash';

import { useAuth } from '@/stores';

import config from '../config';


const instance = new QueueManager({
  serviceUrl: config.QUEUE_MANAGER_API_URL,
  discoveryUrl: `${config.SERVICE_DISCOVERY_API_URL}`,
  feature: config.FEATURE,
  token: () => {
    return `USER ${_.get(useAuth(), 'token')}`;
  },
});

export default instance;
